import { useCanvasTopOffset } from 'automation-ui-canvas/utils/styleUtils';
import styled from 'styled-components';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_PANEL_WIDTH = 460;
const StyledPanelContainer = styled.div.withConfig({
  displayName: "FlowViewSidePanel__StyledPanelContainer",
  componentId: "sc-5zc87y-0"
})(({
  $canvasTopOffset
}) => {
  return {
    position: 'fixed',
    transition: '0.15s ease',
    overflow: 'inherit',
    height: `calc(100vh - ${$canvasTopOffset}px) !important`,
    top: `${$canvasTopOffset}px`
  };
});
const FlowViewSidePanel = ({
  flow,
  canvasScrollElementRef,
  sidePanelConfig,
  onCancel,
  viewData
}) => {
  const canvasTopOffset = useCanvasTopOffset(canvasScrollElementRef);
  const width = sidePanelConfig.width || DEFAULT_PANEL_WIDTH;
  return /*#__PURE__*/_jsx(StyledPanelContainer, {
    $canvasTopOffset: canvasTopOffset,
    children: /*#__PURE__*/_jsx(Panel, {
      width: width,
      align: "right",
      children: /*#__PURE__*/_jsx(sidePanelConfig.SidePanelComponent, {
        flow: flow,
        width: width,
        viewData: viewData,
        onCancel: onCancel
      })
    })
  });
};
export default FlowViewSidePanel;